<template>
    <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
    >
        <template v-slot:activator="{ on }">
            <v-text-field
                v-model="formattedDate"
                :value="value"
                :label="label"
                :error-messages="errorMessages"
                readonly
                v-on="on"
            ></v-text-field>
        </template>
        <v-date-picker
                ref="picker"
                locale="es-es"
                v-model="date"
                :max="max"
                :min="min"
                @change="save"
        ></v-date-picker>
    </v-menu>
</template>

<script>
    export default {
        props:{
            label:{
              type: String,
              default: 'Fecha de nacimiento'
            },
            errorMessages:{
                type: String,
                default: ''
            },
            value:{
                type: String,
                default:''
            }
        },
        data: (vm) => ({
            date: vm.value && vm.$moment(vm.value).format('YYYY-MM-DD') || '',
            menu: false
        }),
        watch: {
            menu (val) {
                val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
            },
            date(val){
                if(val){
                    var vm = this
                    var formatted = vm.$moment(val).format('YYYY-MM-DD')
                    vm.$emit('change', formatted)
                }
            },
            value(val){
                var vm = this
                vm.date = val ? vm.$moment(val).format('YYYY-MM-DD') : ''
            }
        },
        computed:{
            min(){
              const date = this.$moment().subtract(110, 'year')
              return date.format('YYYY-MM-DD')
            },
            max(){
                const date = this.$moment().subtract(1, 'day')
                return date.format('YYYY-MM-DD')
            },
            formattedDate: {
                get(){
                    var vm = this

                    if(!vm.date) return ''

                    if(!vm.asCalendar){
                        return vm.$moment(vm.date).format('DD-MM-YYYY')
                    }

                    return vm.$moment(vm.date).calendar(null,{
                        lastDay : '[Ayer]',
                        sameDay : '[Hoy]',
                        nextDay : '[Mañana]',
                        lastWeek : '[Pasado] dddd',
                        nextWeek : '[Próximo] dddd',
                        sameElse : 'DD-MM-YYYY'
                    }) //.format('DD-MM-YYYY')
                },
                set(val)
                {
                    var vm = this
                    vm.date = val ? vm.$moment(val).format('YYYY-MM-DD') : ''
                }
            }
        },
        methods: {
            save (date) {
                this.$refs.menu.save(date)
                this.menu = false
            }
        },
    }
</script>
